import { createContext } from "react";

/**
 * What a channel pane knows about the panel it sits in: how to close or open it.
 */
export const FeedPanelContext = createContext<{
  closePanel?: () => void;
  openPanel?: () => void;
}>({});
